var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashBinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 112L132 432C132.95 450.49 146.4 464 164 464H348C365.67 464 378.87 450.49 380 432L400 112",
    stroke: "#FF0F0F",
    strokeWidth: 32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 112H432Z",
    fill: "#FF0F0F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 112H432",
    stroke: "#FF0F0F",
    strokeWidth: 32,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192 112V72C191.991 68.8457 192.605 65.7206 193.808 62.8047C195.011 59.8887 196.778 57.2393 199.009 55.0088C201.239 52.7784 203.889 51.0109 206.805 49.8081C209.721 48.6052 212.846 47.9907 216 48H296C299.154 47.9907 302.279 48.6052 305.195 49.8081C308.111 51.0109 310.761 52.7784 312.991 55.0088C315.222 57.2393 316.989 59.8887 318.192 62.8047C319.395 65.7206 320.009 68.8457 320 72V112M256 176V400M184 176L192 400M328 176L320 400",
    stroke: "#FF0F0F",
    strokeWidth: 32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBinIcon);
export default __webpack_public_path__ + "static/media/trash_bin_icon.cfc490889d1049aaa3f5b6ec664b51ed.svg";
export { ForwardRef as ReactComponent };